import { isValidPassword } from 'app/utils/validatePassword'
import { UserInviteFormState } from '..'

export const userInviteValidation = (values: UserInviteFormState) => {
  const errors: Partial<UserInviteFormState> = {}
  if (!values.password) {
    errors.password = 'Campo richiesto'
  } else if (!isValidPassword(values.password)) {
    errors.password = 'La password non soddisfa i requisiti'
  }

  if (!values.passwordConfirmation) {
    errors.passwordConfirmation = 'Campo richiesto'
  } else if (
    values.password &&
    values.password.length &&
    values.passwordConfirmation &&
    values.passwordConfirmation.length &&
    values.password !== values.passwordConfirmation
  ) {
    errors.passwordConfirmation = 'La password deve coincidere'
  }
  return errors
}
